import type { LightboxExternalProps } from 'yet-another-react-lightbox';

/**
 * Pozadie galérie fotiek - spoločné pre detail podnetu občana
 * (`ReportPhotos`) aj pre administráciu (`ReportDetailAdminPage`).
 *
 * Predvolená plná čierna pôsobila ako iná obrazovka; stlmená priehľadná
 * vrstva s rozmazaním nechá vidieť, odkiaľ sa galéria otvorila. Farba je
 * tmavá teplá z palety (tá istá ako prekrytie `+N` pri náhľadoch), nie čistá
 * čierna, a nepriehľadnosť drží kontrast pre biele ovládanie galérie.
 */
export const LIGHTBOX_STYLES: LightboxExternalProps['styles'] = {
  container: {
    backgroundColor: 'rgba(23, 21, 18, 0.72)',
    backdropFilter: 'blur(8px)',
  },
};
